define("shared/components/shared/post/secondary/saved-captions/list", ["exports", "@ember/component", "@ember/object", "@ember/object/computed", "@ember/service", "@ember/utils", "@glimmer/component", "@glimmer/tracking", "later/lib/filter-by-fields", "@ember/template-factory"], function (_exports, _component, _object, _computed, _service, _utils, _component2, _tracking, _filterByFields, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/object/computed",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component",0,"@glimmer/tracking",0,"later/lib/filter-by-fields",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <section
    class="o--modalBody--secondary u--p__lr__0 has--footer cMT--scrollContainer"
    data-test-id="saved-captions-list"
    {{perfect-scroll}}
  >
    <form class="o--formWrapper u--p__lr__lg u--m__b" onsubmit={{this.preventReload}}>
      <Input
        @type="search"
        @value={{this.searchString}}
        class="o--form__input qa--savedCaptions_input"
        placeholder={{t "posts.template.search_placeholder"}}
      />
    </form>
    <ul class="u--listUnstyle qa--savedCaptionsList">
      <li class="cMT--list__item u--p__tb__md qa--savedCaptions_copyText_btn" {{on "click" this.copyCurrentText}}>
        <span class="u--text--hl" data-test-id="copy-button">
          {{t "posts.template.copy_current_text"}}
        </span>
      </li>
      {{#each this.filteredCaptions as |savedCaption|}}
        <li class="cMT--list__item qa--savedCaptionsList_item" {{on "click" (fn this.insertCaption savedCaption)}}>
          <h4 class="cMT--list__title u--ellipsis {{if savedCaption.title.length '' 'u--text--light'}}">
            {{#if savedCaption.title.length}}
              {{savedCaption.title}}
            {{else}}
              {{t "posts.template.untitled"}}
            {{/if}}
          </h4>
          <a
            class="cMT--list__action u--text--uppercase qa--savedCaptionsList_edit"
            {{on "click" (fn @setCaptionToEdit savedCaption)}}
          >
            {{t "shared_words.edit"}}
          </a>
          <span class="cMT--list__action--hide">
            {{t "posts.template.insert_hint"}}
          </span>
          <p class="cMT--list__text">
            {{savedCaption.trimmedContent}}
          </p>
        </li>
      {{/each}}
    </ul>
  </section>
  */
  {
    "id": "FN8Ufx2G",
    "block": "[[[11,\"section\"],[24,0,\"o--modalBody--secondary u--p__lr__0 has--footer cMT--scrollContainer\"],[24,\"data-test-id\",\"saved-captions-list\"],[4,[38,0],null,null],[12],[1,\"\\n  \"],[10,\"form\"],[14,0,\"o--formWrapper u--p__lr__lg u--m__b\"],[15,\"onsubmit\",[30,0,[\"preventReload\"]]],[12],[1,\"\\n    \"],[8,[39,1],[[24,0,\"o--form__input qa--savedCaptions_input\"],[16,\"placeholder\",[28,[37,2],[\"posts.template.search_placeholder\"],null]]],[[\"@type\",\"@value\"],[\"search\",[30,0,[\"searchString\"]]]],null],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,\"ul\"],[14,0,\"u--listUnstyle qa--savedCaptionsList\"],[12],[1,\"\\n    \"],[11,\"li\"],[24,0,\"cMT--list__item u--p__tb__md qa--savedCaptions_copyText_btn\"],[4,[38,3],[\"click\",[30,0,[\"copyCurrentText\"]]],null],[12],[1,\"\\n      \"],[10,1],[14,0,\"u--text--hl\"],[14,\"data-test-id\",\"copy-button\"],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"posts.template.copy_current_text\"],null]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"],[42,[28,[37,5],[[28,[37,5],[[30,0,[\"filteredCaptions\"]]],null]],null],null,[[[1,\"      \"],[11,\"li\"],[24,0,\"cMT--list__item qa--savedCaptionsList_item\"],[4,[38,3],[\"click\",[28,[37,6],[[30,0,[\"insertCaption\"]],[30,1]],null]],null],[12],[1,\"\\n        \"],[10,\"h4\"],[15,0,[29,[\"cMT--list__title u--ellipsis \",[52,[30,1,[\"title\",\"length\"]],\"\",\"u--text--light\"]]]],[12],[1,\"\\n\"],[41,[30,1,[\"title\",\"length\"]],[[[1,\"            \"],[1,[30,1,[\"title\"]]],[1,\"\\n\"]],[]],[[[1,\"            \"],[1,[28,[35,2],[\"posts.template.untitled\"],null]],[1,\"\\n\"]],[]]],[1,\"        \"],[13],[1,\"\\n        \"],[11,3],[24,0,\"cMT--list__action u--text--uppercase qa--savedCaptionsList_edit\"],[4,[38,3],[\"click\",[28,[37,6],[[30,2],[30,1]],null]],null],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"shared_words.edit\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,1],[14,0,\"cMT--list__action--hide\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"posts.template.insert_hint\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,2],[14,0,\"cMT--list__text\"],[12],[1,\"\\n          \"],[1,[30,1,[\"trimmedContent\"]]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[1]],null],[1,\"  \"],[13],[1,\"\\n\"],[13]],[\"savedCaption\",\"@setCaptionToEdit\"],false,[\"perfect-scroll\",\"input\",\"t\",\"on\",\"each\",\"-track-array\",\"fn\",\"if\"]]",
    "moduleName": "shared/components/shared/post/secondary/saved-captions/list.hbs",
    "isStrictMode": false
  });
  let ListComponent = _exports.default = (_dec = (0, _computed.filterBy)('auth.currentGroup.savedCaptions', 'isLoaded'), _dec2 = (0, _computed.sort)('visibleCaptions', 'captionSorting'), (_class = class ListComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "secondaryModal", _descriptor2, this);
      _initializerDefineProperty(this, "segment", _descriptor3, this);
      _defineProperty(this, "captionSorting", ['timesUsed:desc']);
      _initializerDefineProperty(this, "searchString", _descriptor4, this);
      _initializerDefineProperty(this, "visibleCaptions", _descriptor5, this);
      _initializerDefineProperty(this, "sortedCaptions", _descriptor6, this);
    }
    get filteredCaptions() {
      if ((0, _utils.isEmpty)(this.searchString)) {
        return this.sortedCaptions;
      }
      return (0, _filterByFields.default)(this.sortedCaptions, ['title', 'content'], this.searchString);
    }
    get clickedFromFirstComment() {
      return this.secondaryModal.isClickedFromFirstComment(this.args.postElementId);
    }
    get currentText() {
      if (this.args.mediaItem) {
        return this.args.mediaItem.defaultCaption;
      } else if (this.clickedFromFirstComment) {
        return this.args.post.firstComment ?? '';
      }
      return this.args.post.caption;
    }
    preventReload(event) {
      event.preventDefault;
      return false;
    }
    copyCurrentText() {
      this.args.createNewSavedCaption(this.currentText);
    }
    insertCaption(caption) {
      const spaceBreak = this.currentText && this.currentText.length ? '\n' : '';
      const newText = this.currentText + spaceBreak + caption.get('content');
      if (this.args.mediaItem) {
        (0, _object.set)(this.args.mediaItem, 'defaultCaption', newText);
      } else if (this.clickedFromFirstComment) {
        (0, _object.set)(this.args.post, 'firstComment', newText);
      } else {
        (0, _object.set)(this.args.post, 'caption', newText);
      }
      caption.updateLastUsed();
      caption.save();
      this._trackUsedCaptionEvent(caption);
    }
    _trackUsedCaptionEvent(caption) {
      const trackingData = {
        social_profile_id: this.args.socialProfile?.id,
        group_id: this.auth.currentGroup.id,
        location: this.args.location,
        saved_caption_title: caption.get('title')
      };
      Object.keys(trackingData).forEach(key => {
        if (trackingData[key] === undefined) {
          delete trackingData[key];
        }
      });
      if (this.args.socialProfile?.isInstagram) {
        Object.assign(trackingData, {
          added_to_captions: !this.clickedFromFirstComment,
          added_to_first_comment: this.clickedFromFirstComment
        });
      }
      this.segment.track('used-saved-caption', trackingData);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "secondaryModal", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "searchString", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "visibleCaptions", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "sortedCaptions", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "preventReload", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "preventReload"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "copyCurrentText", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "copyCurrentText"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "insertCaption", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "insertCaption"), _class.prototype)), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ListComponent);
});